import { useEffect } from "react";

import { useSocket } from "@/connection/socket";
import { useTypedSelector } from "@/store/reducers/use-typed-selector";
import { IAnnouncement } from "@/types/working-model";
import { getCurrentPageSourceInfo } from "@/utils/tracking";
import { showAnnouncement } from "@general-ui/alert/alert-service";
import { useLanguageParam, getDefaultLanguage } from "../utils";

// announcements sent to the `registered` recipients group - lives above <Routes> so it isn't tied to nav items
const useRegisteredAnnouncementSocket = ({ hasAccess }: { hasAccess: boolean }): void => {
	const eventBundle = useTypedSelector(state => state.LiveEventReducer.eventBundle);
	const blProfile = useTypedSelector(state => state.LiveEventReducer.blProfileUser);
	const language = useLanguageParam();
	const baseLanguage = eventBundle ? getDefaultLanguage(eventBundle) : '';

	const socket = useSocket(`registered-${eventBundle?.uuid}-${language}`);
	useEffect(() => {
		if (!hasAccess) return;
		const handleAnnouncement = ({ data }: { data: Partial<IAnnouncement>; }) => {
			if (eventBundle) {
				const { source_id, source_type } = getCurrentPageSourceInfo(location.pathname, eventBundle, blProfile?.bl_profile || 0);
				showAnnouncement({ ...data, language, baseLanguage, source_id, source_type });
			}
		};
		socket.addListener('announcement', handleAnnouncement);
		return () => {
			socket.removeListener('announcement', handleAnnouncement);
		};
	}, [baseLanguage, blProfile?.bl_profile, eventBundle, hasAccess, language, socket]);
};

export default useRegisteredAnnouncementSocket;
